export enum AuctionStatus {
  IN_PROGRESS = "IN_PROGRESS", // the auction is currently ongoing
  PENDING_TO_BE_EXECUTED = "PENDING_TO_BE_EXECUTED",
  ENDED = "ENDED", //  the auction has ended and the winner has been declared
  CANCELLED = "CANCELLED", // the auction has been cancelled before it could complete
  DRAFT = "DRAFT", // the auction has been cancelled before it could complete
  UNLISTED = "UNLISTED", // the auction has been cancelled before it could complete
  PENDING_STRIPE_PAYMENT = "PENDING_STRIPE_PAYMENT",
}
